// extracted by mini-css-extract-plugin
module.exports = {"impact":"Y66Ba","impact-content":"gxnCC","tabs":"+Z6yr","tabs-container":"WO91t","impact-footer":"mZiLg"};